import { useReduxState } from 'hooks';
import { FlexContainer, Search, SortBy } from 'components/common';
import { FiltersActive } from 'components/common/filter';
import {
  CalendarEventParticipantsAttributeFilter,
  CalendarEventParticipantsViewSelector
} from '.';

import type { CustomAttributes } from 'shared-types';
import type { CalendarEventParticipantsView } from './CalendarEventParticipantsViewSelector';

export type CalendarFilters = {
  customAttributes: string;
  search: string;
  sortBy: 'added' | 'name' | 'participated' | 'status';
  view: CalendarEventParticipantsView;
};

interface Props {
  onFilter: (args: Partial<CalendarFilters>) => void;
  search: string;
  sortBy: CalendarFilters['sortBy'];
  view: CalendarEventParticipantsView;
}

const CalendarEventParticipantsAddedFilter = ({
  onFilter,
  search,
  sortBy,
  view
}: Props) => {
  const {
    messages,
    pageState: { calendarEvent }
  } = useReduxState();

  const handleCustomAttributes = (attributes: CustomAttributes) =>
    onFilter({ customAttributes: JSON.stringify(attributes || {}) });

  const handleSort = ({ sortBy }) => onFilter({ sortBy });

  const handleSearch = ({ search }) => onFilter({ search });

  const handleView = (selectedView) => onFilter({ view: selectedView });

  const sortOptions = [
    {
      text: messages.commonName,
      value: 'name'
    },
    {
      text: messages.commonAdded,
      value: 'added'
    },
    {
      text: messages.eventCalendarParticipantParticipated,
      value: 'participated'
    }
  ];

  return (
    <>
      <FlexContainer
        style={{
          flexWrap: 'wrap',
          gap: 10,
          justifyContent: 'space-between',
          width: '100%'
        }}
      >
        <FlexContainer style={{ flexWrap: 'wrap', gap: 10 }}>
          <div style={{ minWidth: 240 }}>
            <Search
              initialValue={search}
              onSearch={handleSearch}
              placeholder={messages.usersSearchUsers}
              size="header"
            />
          </div>

          {calendarEvent.userAttributes?.length ? (
            <CalendarEventParticipantsAttributeFilter filterId="calendar-event-participants-added-filter" />
          ) : null}
        </FlexContainer>

        <FlexContainer style={{ gap: 10 }}>
          {calendarEvent.userAttributes?.length ? (
            <CalendarEventParticipantsViewSelector
              onChange={handleView}
              view={view}
            />
          ) : null}

          <SortBy onChange={handleSort} options={sortOptions} value={sortBy} />
        </FlexContainer>
      </FlexContainer>

      <FiltersActive filterId="calendar-event-participants-added-filter" />
    </>
  );
};

export default CalendarEventParticipantsAddedFilter;
